import '../styles/Primitives.scss';
import { mergeSx } from '../_internal/styleProps';

export default function LinearProgress({ className = '', style, sx, value = 0, variant, ...props }) {
  const safeValue = Math.max(0, Math.min(100, Number(value) || 0));
  return <div aria-valuemax="100" aria-valuemin="0" aria-valuenow={safeValue} role="progressbar" className={`ui-linear-progress ${className}`.trim()} style={mergeSx(sx, style)} {...props}><div className="ui-linear-progress__bar" style={{ width: `${safeValue}%` }} /></div>;
}
